/**
 * A discount for a hand-picked list of token ids (e.g. #15, #17, #25) on one
 * contract. Every listed token shares the one discount and its optional cap.
 */

/** Must match the server's limit; a longer set should be a token ID range. */
export const MAX_TOKEN_LIST_IDS = 200;

/**
 * Parse what a merchant typed ("15, 17 25", "#15,#17") into token ids:
 * de-duplicated and sorted numerically, as the server stores them.
 */
export function parseTokenIdList(input: string): { ids: string[]; invalid: string[] } {
  const parts = input
    .split(/[\s,;]+/)
    .map((p) => p.trim().replace(/^#/, ''))
    .filter(Boolean);
  const invalid = parts.filter((p) => !/^\d+$/.test(p));
  const valid = parts.filter((p) => /^\d+$/.test(p)).map((p) => BigInt(p).toString());
  const ids = Array.from(new Set(valid)).sort((a, b) => {
    const d = BigInt(a) - BigInt(b);
    return d < BigInt(0) ? -1 : d > BigInt(0) ? 1 : 0;
  });
  return { ids, invalid };
}

/** "Tokens #15, #17, #25" — long lists are shortened for table cells. */
export function formatTokenList(tokenIds: string[], maxShown = 6): string {
  const shown = tokenIds.slice(0, maxShown).map((id) => `#${id}`);
  const more = tokenIds.length - shown.length;
  return `Tokens ${shown.join(', ')}${more > 0 ? ` +${more} more` : ''}`;
}
